<app-card-template title="Información del lote actual" [cardClass]="large ? 'fill-card' : ''">
  <app-lot-status-tag
    *ngIf="showBiddingIndicator"
    cardHeaderActions
    [active]="isReceivingBids"
    [paused]="isPaused"
    [cutting]="cutting"
    [editing]="editing"
    [large]="large">
  </app-lot-status-tag>
  <button
    mat-icon-button
    *ngIf="showEditButton && lotData"
    cardHeaderActions
    class="edit-lot-button"
    matTooltip="Editar lote actual"
    (click)="onEditClick()">
    <mat-icon>edit</mat-icon>
  </button>
  <div *ngIf="hasLotContent" class="auction-event-info">
    <div class="info-grid">
      <div class="info-column">
        <div class="info-row">
          <span class="label">Lote actual:</span>
          <span class="value value--current-lot">{{ displayLotCode }}</span>
        </div>
        <div class="info-row" *ngIf="lotData">
          <span class="label">Valor puja:</span>
          <span class="value">{{ lotData.bid | multiMoney : null : exchangeRates }}</span>
        </div>
        <div class="info-row" *ngIf="lotData">
          <span class="label">Valor animal:</span>
          <span class="value">{{ lotData.getAnimalPrice() | multiMoney : null : exchangeRates }}</span>
        </div>
        <div class="info-row" *ngIf="lotData">
          <span class="label">Valor actual:</span>
          <span class="value">{{ lotData.sysPrice | multiMoney : null : exchangeRates }}</span>
        </div>
        <div class="info-row" *ngIf="lotData && extendedDetails">
          <span class="label">Vlr Total:</span>
          <span class="value">{{ lotData.getTotalPrice() | multiMoney : null : exchangeRates }}</span>
        </div>
        <div class="info-row" *ngIf="lotData && extendedDetails">
          <span class="label">Hora Llegada:</span>
          <span class="value">{{ lotData.arrivedTime | showOnlyHours }}</span>
        </div>
        <div class="info-row" *ngIf="lotData && extendedDetails">
          <span class="label">Procedencia:</span>
          <span class="value">{{ lotData.origin || '-' }}</span>
        </div>
       
      </div>
      <div class="info-column" *ngIf="lotData">
        <div class="info-row">
          <span class="label">Valor base:</span>
          <span class="value">{{ lotData.basePrice | multiMoney : null : exchangeRates }}</span>
        </div>
        <div class="info-row">
          <span class="label">Peso promedio:</span>
          <span class="value">{{ lotData.getAvgWeight() | number : '1.0-0' }}</span>
        </div>
        <div class="info-row">
          <span class="label">Cantidad:</span>
          <span class="value">{{ lotData.quantity }}</span>
        </div>
        <div class="info-row">
          <span class="label">Categoría:</span>
          <span class="value">{{ lotData.category }}</span>
        </div>
         <div class="info-row" *ngIf="lotData && extendedDetails">
          <span class="label">Valor kilo:</span>
          <span class="value">{{ lotData.getKiloPrice() | multiMoney : null : exchangeRates }}</span>
        </div>
        <div class="info-row" *ngIf="extendedDetails">
          <span class="label">Peso total:</span>
          <span class="value">{{ lotData.weight | number : '1.0-0' }}</span>
        </div>
        <div class="info-row" *ngIf="extendedDetails">
          <span class="label">Proveedor:</span>
          <span class="value">{{ lotData.providerName || '-' }}</span>
        </div>
      </div>
      <div class="info-row info-row--full info-row--paragraph" *ngIf="lotData && extendedDetails">
        <span class="label">Observaciones:</span>
        <span class="value">{{ lotData.observations || '-' }}</span>
      </div>
      <div class="info-row info-row--full" *ngIf="lotData && extendedDetails">
        <span class="label label--next-bid">Valor de la siguiente puja:</span>
        <span class="value value--next-bid">{{ lotData.getNextBidValue() | multiMoney : null : exchangeRates }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!hasLotContent" class="no-data">
    <p>No hay información del lote disponible</p>
  </div>
</app-card-template>
